import { connect } from "react-redux";

import { actions as modalReauthorizeActions } from "./ModalReauthorize.redux";
import { actions as loginActions } from "../login";

import ModalReauthorize from "./ModalReauthorize.view";

const mapStateToProps = state => ({
  showModalReauthorize: state.showModalReauthorize,
  user: state.login.user,
});

const mapDispatchToProps = dispatch => ({
  login: data => dispatch(loginActions.login(data)),
  toggleModalReauthorize: () => dispatch(modalReauthorizeActions.toggle()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalReauthorize);
